import React, { useState } from "react"
import Card from "@material-ui/core/Card"
import IconButton from "@material-ui/core/IconButton"
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import moment from 'moment'
import Tooltip from "@material-ui/core/Tooltip"
import axios from 'axios'
import { useTranslation } from "react-i18next"

// Dialog Imports
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

function CoafOccurrenceCard(props) {
    const { t } = useTranslation()
    const { 
        flexColumnStyles,
        occurrence,
        setOccurrenceDialogState,
        setBatchDialogState,
        refreshList,
        setSnackbarContent
    } = props
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    const openViewOccurrenceDialog = () => {
        setOccurrenceDialogState({
            open: true,
            mode: "view",
            occurrence: occurrence
        })
    }

    const openEditOccurrenceDialog = () => {
        setOccurrenceDialogState({
            open: true,
            mode: "edit",
            occurrence: occurrence
        })
    }

    const openViewBatchDialog = () => {
        if(!occurrence.communication_batch_key) return
        setBatchDialogState({
            open: true,
            mode: "view",
            batch: {
                occurrence_batch_key: occurrence.communication_batch_key,
                occurrence_batch_external_id: occurrence.communication_batch_external_id,
                occurrences: []
            }
        })
    }

    const handleDeleteClick = () => {
        setOpenDeleteConfirm(true)
    }

    const handleCloseDeleteConfirm = () => {
        setOpenDeleteConfirm(false)
    }

    const confirmDelete = async () => {
        setIsDeleting(true)
        try {
            await axios.delete(`/dash/alerts/occurrence/${occurrence.occurrence_key}`)
            setOpenDeleteConfirm(false)
            if (refreshList) {
                refreshList()
            }
        } catch (error) {
            setSnackbarContent({
                type: "error",
                message: "Ocorreu um erro ao excluir a ocorrência. Por favor tente novamente mais tarde."
            })
        } finally {
            setIsDeleting(false)
        }
    }

    const clickableElementClasses = ["link", "subtitleSize", "bold"].join(" ")
    const readOnlyElementClasses = ["listCardItem", "normalText", "subtitleSize"].join(" ")
    const isEditable =  occurrence.status === "out_of_batch" || occurrence.communication_batch_status === "draft"

    return (
        <Card className="listCard">
            <div
                className={clickableElementClasses}
                style={{ flex: flexColumnStyles[0], alignSelf: "center", textAlign: "center" }}
                onClick={openViewOccurrenceDialog}
            >
                {occurrence.external_id}
            </div>
            <div
                className={
                    occurrence.communication_batch_key ? clickableElementClasses : readOnlyElementClasses
                }
                onClick={openViewBatchDialog}
                style={{ flex: flexColumnStyles[1], alignSelf: "center", textAlign: "center" }}
            >
                {occurrence.communication_batch_external_id || t("Nenhum Lote")}
            </div>
            <div
                className={readOnlyElementClasses}
                style={{ flex: flexColumnStyles[2], alignSelf: "center", textAlign: "center" }}
            >
                {occurrence.regulatory_authority === "cvm" ? t("CVM") : t("BACEN")}
            </div>
            <div
                className={readOnlyElementClasses}
                style={{ flex: flexColumnStyles[3], alignSelf: "center", textAlign: "center" }}
            >
                {moment(occurrence.created_at).format("DD/MM/YYYY HH:mm:ss")}
            </div>
            <div
                style={{
                    flex: flexColumnStyles[4],
                    alignSelf: "center",
                    textAlign: "center",
                }}
            >
                <Tooltip title={t("Editar Ocorrência")}>
                    <span>
                        <IconButton
                            onClick={openEditOccurrenceDialog}
                            disabled={!isEditable}
                        >
                            <EditIcon color={isEditable ? "primary" : "disabled"} />
                        </IconButton>
                    </span>
                </Tooltip>

                <Tooltip title={t("Excluir Ocorrência")}>
                    <span>
                        <IconButton
                            onClick={handleDeleteClick}
                            disabled={!isEditable}
                        >
                            <DeleteIcon color={isEditable ? "error" : "disabled"} />
                        </IconButton>
                    </span>
                </Tooltip>
            </div>

            <Dialog
                open={openDeleteConfirm}
                onClose={handleCloseDeleteConfirm}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ color: "#0b1f82", fontWeight: "bold" }}>{`${t("Excluir")} ${t("Ocorrência")}?`}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {`${t("Tem certeza que deseja excluir")}: `} 
                        <b>{`${t("ocorrência")} `}{occurrence.external_id}</b>?
                        <br/>
                        {t("Esta ação não pode ser desfeita.")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteConfirm}
                        className="button onlyboarder normalText normalMediumSize"
                        disabled={isDeleting}>
                        {t("Cancelar")}
                    </Button>
                    <Button onClick={confirmDelete}
                        className="button standard normalText normalMediumSize"
                        disabled={isDeleting}>
                        {isDeleting ? `${t("Excluindo")}...` : t("Excluir")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    )
}

export default CoafOccurrenceCard